export default {
  id: '23423523',
  type: 'button',
  category: 'basic',
  // active: false, ?
  content: {
    text: 'Click Me',
  },
  settings: {
    action: 'next',
    href: '',
    backBtn: true,
  },
  /*  Keep the styling even in flattened json structure cause vue ease of use */
  styling: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: '400',
    color: 'rgb(255, 255, 255)',
    backgroundColor: 'rgb(24, 23, 26)',
    justifyContent: 'center',
    borderRadius: '5px',
    borderWidth: '2px',
    borderColor: 'rgb(0, 0, 0)',
  },
}
